export function clamp(value: number, minimum: number, maximum: number): number {
  return Math.max(minimum, Math.min(maximum, value));
}

export function roundedRectPath(
  context: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  radius: number,
): void {
  const corner = Math.min(radius, width / 2, height / 2);
  context.beginPath();
  context.moveTo(x + corner, y);
  context.lineTo(x + width - corner, y);
  context.quadraticCurveTo(x + width, y, x + width, y + corner);
  context.lineTo(x + width, y + height - corner);
  context.quadraticCurveTo(x + width, y + height, x + width - corner, y + height);
  context.lineTo(x + corner, y + height);
  context.quadraticCurveTo(x, y + height, x, y + height - corner);
  context.lineTo(x, y + corner);
  context.quadraticCurveTo(x, y, x + corner, y);
  context.closePath();
}

export function drawPanel(
  context: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  accent: string,
): void {
  context.save();
  roundedRectPath(context, x, y, width, height, 18);
  context.fillStyle = "rgba(5, 11, 20, 0.82)";
  context.fill();
  context.strokeStyle = "rgba(255, 255, 255, 0.16)";
  context.lineWidth = 2;
  context.stroke();
  context.fillStyle = accent;
  roundedRectPath(context, x, y, 7, height, 4);
  context.fill();
  context.restore();
}

export function drawScanlines(
  context: CanvasRenderingContext2D,
  color = "rgba(255, 255, 255, 0.025)",
): void {
  context.save();
  context.strokeStyle = color;
  context.lineWidth = 1;
  for (let y = 1; y < 720; y += 6) {
    context.beginPath();
    context.moveTo(0, y);
    context.lineTo(1280, y);
    context.stroke();
  }
  context.restore();
}

export function setText(
  context: CanvasRenderingContext2D,
  size: number,
  weight: number,
  color: string,
  align: CanvasTextAlign = "left",
): void {
  context.fillStyle = color;
  context.textAlign = align;
  context.textBaseline = "middle";
  context.font = `${weight} ${size}px "Avenir Next", "Helvetica Neue", sans-serif`;
}
